import { ToolkitStore } from "@reduxjs/toolkit/dist/configureStore";
import axios, { AxiosRequestConfig } from "axios";
import qs from "qs";
import { all, fork } from "redux-saga/effects";
import screenSaga from "./screen/saga";

export const invokeAPI = async (option: AxiosRequestConfig) => {
  let url: string = option.url ?? "";
  const { method = "GET" } = option;

  if (method.toUpperCase() === "GET") {
    if (option.data) {
      const queryString: string = qs.stringify(option.data);
      url = `${url}?${queryString}`;
    }
  }
  const headers = option.headers ?? { "Content-Type": "application/json" };
  const params: AxiosRequestConfig = {
    ...option,
    headers,
    url: url,
  };

  if (option.responseType) {
    params.responseType = option.responseType;
  }

  return await axios(params);
};

export default function* rootSaga() {
  yield all([
    // public
    fork(screenSaga)
  ]);
}
